/**
 * Navbar for subscription flow (Figma 6127-17861, 6185-9415).
 * Logo from Figma 6127-17862; mobile logo from Figma 6180-7687; background #FF9AF5 per design.
 */

import { Link, useLocation } from 'react-router-dom';
import {
  isMobile,
  SIZE_LG,
  SIZE_MD,
  SIZE_SM,
  SIZE_XS,
} from '../../../../../hooks/useBreakPoint';

import { ROUTE_HOME, ROUTE_UNLIMITED } from '../../../config/routes';
import trashieLogo from '../../../images/trashie-logo.webp';
import mobileNavbarLogo from '../../../images/subscription-navbar-mobile-logo.svg';
import SubscriptionUnlimitedMenuDrawer from './SubscriptionUnlimitedMenuDrawer';

import './SubscriptionNavbar.scss';

const SubscriptionNavbar = () => {
  const { pathname } = useLocation();
  const isMobileWidth = isMobile([SIZE_XS, SIZE_SM, SIZE_MD, SIZE_LG]);
  const logoSrc = isMobileWidth ? mobileNavbarLogo : trashieLogo;
  const showUnlimitedMenu = pathname === ROUTE_UNLIMITED;

  return (
    <nav className="SubscriptionNavbar" aria-label="Subscription navigation">
      <div className="SubscriptionNavbar__container">
        <Link className="SubscriptionNavbar__logo" to={ROUTE_HOME}>
          <img
            className="SubscriptionNavbar__logo-img"
            src={logoSrc}
            alt="Trashie"
          />
        </Link>
        {showUnlimitedMenu && <SubscriptionUnlimitedMenuDrawer />}
      </div>
    </nav>
  );
};

export default SubscriptionNavbar;
